<template>
    <div
        :class="{ 'waterfall-item-active': isSelected, 'waterfall-item-readonly': readonly }"
        :style="transformStyle"
        class="waterfall-item"
    >
        <MaskChecked v-show="!readonly && isSelected" />
        <template v-if="!isMulti">
            <p class="main-title">
                {{ getMainTitle }}
            </p>
        </template>
        <p class="date">
            {{ getFormatDate }}
        </p>
        <div
            :class="isMulti ? 'multi' : ''"
            class="item-pic"
        >
            <div
                :style="getMainImgStyle"
                class="img"
            />
            <p
                v-if="isMulti"
                class="multi-img-txt-title"
            >
                {{ getMainTitle }}
            </p>
        </div>
        <p
            v-if="!isMulti"
            :class="!getMainSummary ? 'empty-summary' : ''"
            class="intro"
        >
            {{ getMainSummary }}
        </p>
        <div
            v-else
            class="sub-img-txt-container"
        >
            <div
                v-for="(cell, index) in item.articles || []"
                v-if="index"
                class="sub-img-txt-item"
            >
                <p>{{ cell.title }}</p>
                <div
                    :style="getSmallImgStyle(cell)"
                    class="small-img"
                />
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import MaskChecked from '../reply-pop/mask-checked';

export default {
    name: 'WaterfallItem',
    components: {
        MaskChecked,
    },
    props: {
        item: {
            type: Object,
            default: {},
        },
        coords: {
            type: Object,
            default: {},
        },
        selected: {
            type: Object,
            default: {},
        },
        index: {
            type: Number,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isChecked: false,
        };
    },
    computed: {
        isMulti() {
            return (this.item.articles || []).length > 1;
        },
        getMainTitle() {
            return this.getMainArticle(this.item).title;
        },
        getFormatDate() {
            return moment(this.item.createTime * 1000).format('YYYY-MM-DD HH:MM');
        },
        getMainImgStyle() {
            const { showUrl } = this.getMainArticle(this.item);
            return `background-image: url("${showUrl && showUrl.replace(/\0$/, '/360')}")`;
        },
        getMainSummary() {
            return this.getMainArticle(this.item).summary;
        },
        transformStyle() {
            return (
                (Object.keys(this.coords).length
                    && `transform: translate3d(${this.coords.x}px, ${this.coords.y}px, 0)`)
                || ''
            );
        },
        isSelected() {
            return this.selected.id === this.item.id;
        },
    },
    mounted() {
        this.$emit('mounted', {
            node: this.$el,
            coords: this.coords,
        });
    },
    methods: {
        getMainArticle(item) {
            return (item.articles || [])[0] || {};
        },
        getSmallImgStyle(cell) {
            const src = cell.showUrl && cell.showUrl.replace(/\/0$/, '/120');
            return `background-image: url("${src}")`;
        },
    },
};
</script>

<style>
.waterfall-item {
    position: absolute;
    left: 0;
    top: 0;
    background-color: #fff;
    display: inline-block;
    width: 315px;
    margin-right: 30px;
    padding-top: 10px;
    margin-bottom: 30px;
    border: 2px solid transparent;
    border-radius: 2px;
    box-shadow: 0 0 0 1px #dadee7;
    transition: all 0.3s;
}
.robot-nav-select .waterfall-item{
    background-color: transparent;
    border:none;
    box-shadow:none;
}
.robot-nav-select .waterfall-item:hover{
    border: none;
}
.waterfall-item.waterfall-item-active,
.waterfall-item:hover {
    border-color: #0067ed;
    border-radius: 4px;
    cursor: pointer;
}

.waterfall-item-readonly:hover {
    border-color: transparent;
    border-radius: 2px;
    cursor: default;
}

.waterfall-item .main-title {
    text-align: left;
    font-size: 16px;
    margin-bottom: 2px;
    padding-left: 13px;
    padding-right: 15px;
    margin-top: 5px;
    word-wrap: break-word;
}

.waterfall-item .date {
    text-align: left;
    color: #a8abb3;
    font-size: 12px;
    padding-left: 13px;
    padding-right: 15px;
    margin-bottom: 12px;
}

.waterfall-item .multi-img-txt-title {
    position: absolute;
    width: 270px;
    line-height: 20px;
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    text-align: left;
    padding: 5px 10px;
    bottom: 5px !important;
    word-wrap: break-word;
}

.waterfall-item .item-pic {
    display: inline-block;
    padding-left: 13px;
    padding-right: 15px;
    padding-bottom: 10px;
    position: relative;
}

.waterfall-item .item-pic.multi {
    padding-bottom: 0;
}

.waterfall-item .item-pic .img {
    display: inline-block;
    width: 290px;
    height: 160px;
    background-position: 50% 50%;
    background-size: cover;
}

.waterfall-item .intro {
    padding-left: 13px;
    padding-right: 13px;
    margin-bottom: 10px;
    margin-top: -5px;
    text-align: left;
    word-wrap: break-word;
    color: #66686c;
}

.waterfall-item .sub-img-txt-container {
    margin-top: 10px;
    border-top: 1px solid #eaebee;
}

.waterfall-item .sub-img-txt-item {
    border-top: 1px solid #eaebee;
    display: inline-block;
    position: relative;
    height: 90px;
    line-height: 90px;
    width: 100%;
}

.waterfall-item .sub-img-txt-item:first-child {
    border-top: 1px solid transparent;
}

.waterfall-item .sub-img-txt-item p {
    width: 220px;
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    line-height: 1.4em;
    word-wrap: break-word;
    max-height: 60px;
    padding-right: 60px;
    overflow: hidden;
}

.waterfall-item .sub-img-txt-item .small-img {
    line-height: 60px;
    display: inline-block;
    position: absolute;
    right: 15px;
    top: 15px;
    width: 60px;
    height: 60px;
    background-position: 50% 50%;
    background-size: cover;
}
</style>
